export default __webpack_public_path__ + "static/media/try.d802370e.svg";